import { configureStore, ThunkAction, UnknownAction } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import reducer from "./ducks";

export const createStore = () => configureStore({ reducer });

export type AppThunkAction<T = void> = ThunkAction<
  T,
  RootState,
  any,
  UnknownAction
>;
export type RootState = ReturnType<typeof reducer>;
export const store = createStore();
export type RootStore = typeof store;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export type Action = UnknownAction | AppThunkAction<any>;
export type ActionCreator<T extends any[]> = (...args: T) => Action;
export type Selector<T> = (state: RootState) => T;
